import 'components/shared/rx'
import 'babel-polyfill'
import React from 'react'
import { LoadStyles } from '@driftt/tide-core-legacy'
import { render } from 'react-dom'
import { syncHistoryWithStore } from 'react-router-redux'
import { locationState } from 'app/modules/router/selectors'
import { appHistory } from 'app/RouterHelpers'
import AppContainer from 'containers/AppContainer'
import app from 'containers/app'
import store from 'containers/store'
import Perf from 'react-addons-perf'

import 'styles/main.styl'

if (__ENV__ !== 'PRODUCTION') {
  window.Perf = Perf
  window.api = require('@driftt/dapper')
  window.Immutable = require('immutable')
  window.store = store
}

// trick SDK into thinking FullStory is loaded
window._fs_namespace = 'FS'

const history = syncHistoryWithStore(appHistory, store, {
  selectLocationState: locationState,
})

function main() {
  window.__DRIFT__recordBootstrapCheckpoint('main.willRenderReactApp')

  const createRoutes = require('app/routes').default

  const routes = createRoutes(store)
  render(
    <AppContainer
        app={app}
        history={history}
        store={store}
        routes={routes}
    />
    , document.getElementById('app'))
}

LoadStyles()
main()



// WEBPACK FOOTER //
// ./src/scripts/main.js